/**
 * expert.solvook.com 도메인으로의 리다이렉트 여부를 체크합니다.
 *
 * expert에서 마켓 로그인 페이지로 이동 후, 로그인 성공 시
 * 다시 expert로 돌아가기 위해 사용됩니다.
 *
 * @param path - 리다이렉트 대상 URL
 * @returns expert 도메인이면 true, 아니면 false
 */ export const isExpertRedirect = (path)=>{
    if (!(path === null || path === void 0 ? void 0 : path.startsWith("http"))) return false;
    try {
        const { origin  } = new URL(path);
        return origin === process.env.NEXT_PUBLIC_EXPERT_URL;
    } catch (e) {
        return false;
    }
};
/**
 * 외부 URL로 리다이렉트합니다.
 *
 * window.location.replace를 사용하여 히스토리를 대체하므로
 * 뒤로가기 시 로그인 페이지로 돌아가지 않습니다.
 *
 * @param url - 이동할 외부 URL
 */ export const navigateToExternalUrl = (url)=>{
    window.location.replace(url);
};
